export default {"src":"/_next/static/media/Logo_Compact_Light.4060c2cc.svg","height":49,"width":37};